import React, { useEffect } from "react";
import clsx from "clsx";
import {
  Box,
  Card,
  Grid,
  makeStyles,
  FormControl,
  TextField,
  Button,
} from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save";
import { NavLink as RouterLink } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { kmMessages } from "src/constant/Messages";
import { fillMissingTags } from "src/utils/utils";

const nameMaxLength = 300;

const formValidation = {
  required: kmMessages.error.form_validation.field_required,
  maxLength: `${kmMessages.error.form_validation.field_maxlengthnum}`,
};

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(2),
    },
  },
  formcontrol: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  paddingbottom: {
    paddingBottom: theme.spacing(1),
  },
  paddingtop: {
    paddingTop: theme.spacing(2),
  },
  button: {
    margin: theme.spacing(1),
  },
}));

const Form = ({ onSubmit, answerOption, editMode, ...rest }) => {
  const classes = useStyles();

  const { handleSubmit, register, setValue, control, errors } = useForm();

  useEffect(() => {
    setTimeout(fillMissingTags(), 1000);
    return () => {};
  }, []);

  useEffect(() => {
    if (editMode) {
      setValue("name", answerOption.name);
    }
    return () => {};
  }, [answerOption]);

  return (
    <Card className={clsx(classes.root)} {...rest}>
        <Box component="main">
          <Grid container className={classes.root}>
            <Grid item xs={12} elevation={2}>
              <form onSubmit={handleSubmit(onSubmit)}>
                <FormControl
                  fullWidth
                  className={classes.formcontrol}
                  variant="outlined"
                >
                  <Controller
                    as={
                      <TextField
                        autoFocus
                        error={errors.name ? true : false}
                        id="name"
                        name="name"
                        label="Nazwa"
                        placeholder="Nazwa"
                        multiline
                        helperText={
                          errors.name &&
                          (formValidation[errors.name.type] || "").replaceAll(
                            "{maxlen}",
                            nameMaxLength
                          )
                        }
                      />
                    }
                    name="name"
                    defaultValue=""
                    control={control}
                    rules={{ required: true, maxLength: nameMaxLength }}
                  />
                </FormControl>
                <Box className={classes.paddingtop}>
                  <Button
                    color="primary"
                    className={classes.button}
                    component={RouterLink}
                    to="/administracja/slowniki/4"
                  >
                    Anuluj
                  </Button>
                  <Button
                    color="primary"
                    variant="contained"
                    className={classes.button}
                    endIcon={<SaveIcon />}
                    type="submit"
                  >
                    Zapisz
                  </Button>
                </Box>
              </form>
            </Grid>
          </Grid>
        </Box>
    </Card>
  );
};

export default Form;
